export class OpportunityContractSearchDto {
  contractNumber: string;
  legalName: string;
  firstName: string;
  lastName: string;
  opportunityName: string;
}
